enum ReplayActionType {
  Segment,
  Arrow,
  Sound,
  HypoStart,
  HypoEnd,
  HypoAction,
  HypoBack,
  HypoToggleRevealed,
  EfficiencyMod,
}
export default ReplayActionType;
